import type { SelectProps } from "@/modules/uiKitOverrides/SelectFilter/Select"
import type { FieldIconTypes, FieldWrapperTypes } from "@jobteaser/ui-kit/components/FieldLayout/FieldLayout.model"
import type { FunctionComponent, ReactNode } from "react"

import classNamesMaker from "classnames"
import { useId } from "react"

// eslint-disable-next-line no-restricted-imports
import { SelectField as SelectFieldUiKit } from "@jobteaser/ui-kit/components/SelectFilter/Select/SelectField"

import styles from "./Select.module.css"

export type SelectFieldProps = {
  commonProps?: Record<string, unknown>
  containerProps?: Record<string, unknown>
  labelProps?: Record<string, unknown>
  fieldWrapperProps?: FieldWrapperTypes
  iconProps?: FieldIconTypes
  switchTextProps?: Record<string, unknown>
  fieldProps?: SelectProps
  linkedPictoProps?: { picto: ReactNode }
}
export const SelectField: FunctionComponent<SelectFieldProps> = props => {
  const { fieldProps, ...restProps } = props
  const uniqueId = useId()
  const uniqueIdToUse = fieldProps?.id || uniqueId

  const overriddenFieldProps = {
    ...fieldProps,
    className: classNamesMaker(styles.select, fieldProps?.className),
    id: uniqueIdToUse,
    instanceId: uniqueIdToUse,
  }

  return <SelectFieldUiKit fieldProps={overriddenFieldProps} {...restProps} />
}
